import type { AppType } from '#/env'

export const env = (key: string, isProd: boolean, defaultValue?: string): string => {
  return (isProd ? process.env[key] : import.meta.env[key]) ?? defaultValue ?? ''
}

export const getAppType = (): AppType => {
  const url = new URL(window.location.href)
  const subDomain = url.hostname.split('.')[0]

  switch (subDomain) {
    case 'security':
      return 'auth'
    case 'dashboard':
      return 'dashboard'
    case 'admin':
      return 'admin'
    default:
      return 'core'
  }
}

export const getApplicationId = () => {
  return env(`VITE_${getAppType().toUpperCase()}_ID`, false)
}
